import http from "../../services/http";


const path = "v1/admin/whitelabelstore/storeId";
export const getStoreId = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: path,
        body,
      });
      // dispatch(addFavorite(body.gameId));
      onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    //   handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

